import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { LoadingService } from '@services/loading.service';

@Component({
  selector: 'app-loading-alert',
  styleUrl: './loading-alert.component.scss',
  templateUrl: './loading-alert.component.html',
})
export class LoadingAlertComponent implements AfterViewInit {
  readonly label = input.required<string>();
  private destroyRef = inject(DestroyRef);
  private dialog = viewChild.required<ElementRef<HTMLElement>>('dialog');
  private loading = inject(LoadingService).get();

  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      if (!this.destroyRef.destroyed && this.loading()) {
        this.dialog().nativeElement.focus();
      }
    });
  }

  @HostListener('document:focusin', ['$event'])
  protected onFocus(event: FocusEvent): void {
    if (!this.dialog().nativeElement.contains(event.target as Node)) {
      this.dialog().nativeElement.focus();
    }
  }

  @HostListener('document:keydown', ['$event'])
  protected onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape' || event.key === 'Tab') {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.dialog().nativeElement.focus();
    }
  }
}
